<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <img class="imgcenter" src="../../assets/common/images/title_guikuang.png" alt="">
      <div class="imagetop mt50" v-if="mainList && mainList.length > 0">
        <swiper class="swipertop" ref="swipertop" :options="swiperOptiontop">
          <swiper-slide class="swiper-slide"
                        v-for="(item, index) in mainList"
                        :key="index">
            <a @click="detaillink(item.menuId, item.id)">
              <div class="imgbox">
                <img class="imgtop" :src="getImage(item.image)" alt="">
              </div>
              <div class="txtbox">
                <h2 class="textover">{{ item.title }}</h2>
                <p class="date textover" v-show="item.address !== undefined && item.address !== ''">地址：{{ item.address }}</p>
                <p class="date textover" v-show="item.phone !== undefined && item.phone !== ''">联系方式：{{ item.phone }}</p>
                <div class="descbox" v-show="item.synopsis !== undefined && item.synopsis !== ''" v-html="'简介：' + item.synopsis"></div>
              </div>
            </a>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination"></div>
      </div>
      <type-screen modelType="pavilion" :menu-id="this.$route.query.columnId" @typeObj="selectType"/>
      <ul class="ul-model5 clearfix mt20">
        <li
          @click.stop="detaillink(item.menuId, item.id)"
          v-for="(item, index) in List"
          :key="index">
          <a>
            <div class="imgbox">
              <img class="icon" v-if="item.detailUrl !== undefined && item.detailUrl !== ''" src="../../assets/common/icon/icon-video1.png" alt="">
              <img class="imgtop" :src="getImage(item.image)" alt="">
            </div>
            <div class="txtbox">
              <h2 class="textover">{{ item.title }}</h2>
              <p class="date textover" v-show="item.address !== undefined && item.address !== ''">地址：{{ item.address }}</p>
              <p class="date textover" v-show="item.phone !== undefined && item.phone !== ''">联系方式：{{ item.phone }}</p>
              <div class="descbox" v-show="item.synopsis !== undefined && item.synopsis !== ''" v-html="'简介：' + item.synopsis"></div>
              <div class="clearfix mt10">
                <star star-style="iconstar1"
                      :is-select="item.isStar"
                      :count="item.star"
                      @changecount="changeStar"
                      :showzero="true"
                      :menu-id="item.menuId"
                      :business-id="item.id"/>
                <span class="more gradientGreenBlue fr">查看详情</span>
              </div>
            </div>
          </a>
        </li>
      </ul>
      <nodata v-show="nodataflag"/>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="Param.limit"
        :pager-count="5"
        :current-page.sync="currentPage"
        layout="prev, pager, next"
        :total="listTotal"
        :showzero="true"
        class="pagemodel1">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import Star from '@/components/amount/star'
import { getPavilionList } from '@/api/pavilion/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import { timeFormat } from '@/utils/validate'
import { scrollAnimation } from '@/utils/index'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { getListAmount } from '@/api/datavolume/index'
export default {
  name: 'pavilion',
  meta: {
    showHeader: true
  },
  components: {
    Star,
    typeScreen,
    crumbs,
    banner,
    nodata,
    swiper,
    swiperSlide
  },
  data () {
    return {
      Param: {
        phone: this.$cookie.get('wlymobilephone'),
        page: 1,
        limit: 9,
        menuId: this.$route.query.columnId,
        types: '',
        type: '',
        grade: ''
      },
      swiperOptiontop: {
        pagination: {
          el: '.imagetop .swiper-pagination'
        }
      },
      star: 0,
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0,
      amountList: [],
      mainList: []
    }
  },
  mounted () {
    this.getList()
    this.getgradeList()
  },
  methods: {
    changeStar (val) {
      console.log(val)
      this.List.forEach((item) => {
        if (item.id === val.id) {
          item.star = val.count
          item.isStar = val.isSelect
        }
      })
    },
    defaultamout (list) {
      list.forEach(item => {
        if (item.star === undefined) item.star = 0
        if (item.isStar === undefined) item.isStar = 'false'
      })
    },
    getTime (val) {
      return timeFormat(val, 'yymmdd').replace(/-/g, '/')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getgradeList () {
      let obj = this.Param
      obj.grade = 0
      getPavilionList(obj).then((res) => {
        if (res.data.list.status === 200) {
          // console.log(res.data)
          if (res.data.list.data.total > 0) {
            this.mainList = res.data.list.data.rows
          } else {
            this.mainList = []
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    getList () {
      this.Param.grade = 1
      getPavilionList(this.Param).then((res) => {
        if (res.data.list.status === 200) {
          this.listTotal = res.data.list.data.total
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          getListAmount(this.$route.query.columnId, {'p': this.$cookie.get('wlymobilephone')}).then((resamout) => {
            if (resamout.data.data.length !== 0) {
              resamout.data.data.forEach(amout => {
                res.data.list.data.rows.forEach(item => {
                  if (amout.dataId === item.id) {
                    item.star = amout.star
                    item.isStar = amout.isStar
                  }
                })
              })
              this.defaultamout(res.data.list.data.rows)
            } else {
              this.defaultamout(res.data.list.data.rows)
            }
            this.List = res.data.list.data.rows
          })
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.page = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    /* 筛选条件 */
    selectType (obj) {
      console.log(obj)
      this.Param.type = obj.type
      this.Param.types = obj.customTypeId
      this.Param.page = 1
      this.currentPage = 1
      this.getList()
      // this.getgradeList()
    },
    detaillink (columnId, id) {
      if (this.$route.query.subhomepage !== undefined) {
        this.$router.push({path: '/paviliondetail', query: {columnId: columnId, id: id, subhomepage: this.$route.query.subhomepage}})
      } else {
        this.$router.push({path: '/paviliondetail', query: {columnId: columnId, id: id}})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.imagetop{
  height: 220px;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 10px;
  box-sizing: border-box;
  margin: 35px auto 60px;
  position: relative;
  .swiper-pagination{
    width: 100%;
    bottom: -28px;
    /deep/ .swiper-pagination-bullet{
      margin: 0 5px;
    }
    /deep/ .swiper-pagination-bullet-active{
      background: #0089a2;
    }
  }
  .imgbox{
    position: absolute;
    top: 0px;
    left: 0px;
    width: 290px;
    height: 200px;
    overflow: hidden;
    background-color: #3c3c3c;
    border-radius: 10px;
  }
  .txtbox{
    height: 200px;
    margin: 0 0 0 310px;
    h2{
      font-size: 20px;
      line-height: 36px;
      letter-spacing: 2px;
    }
    p,
    .descbox{
      line-height: 32px;
      color: #3c3c3c;
    }
  }
}
.ul-model5{
  li{
    a{
      border-radius: 6px;
      padding: 0;
      overflow: hidden;
      .txtbox{
        height: 200px;
      }
    }
  }
}
.conditioncon-1{
  /deep/ .overflowbox{
    .overflowinner{
      ul{
        li{
          height: 36px;
          line-height: 36px;
          background-image: linear-gradient(90deg, #89bbeb 0%, #4c9be5 100%);
          border-radius: 10px;
          border: solid 1px #4c9be5;
          margin: 4px 8px 6px 0px;
          a{
            color: #fff;
            line-height: 34px;
          }
          &:nth-child(1){
            top: 5px;
            background: none;
            border: none;
            margin: 0;
            a{
              color: #333;
            }
            &.selected,
            &:hover{
              background: none;
              color: #333;
              border: none;
            }
          }
          &.selected,
          &:hover{
            background-image: linear-gradient(90deg, #eac263 0%, #ffecbc 100%);
            border: solid 1px #c89f66;
            a{
              color: #754917;
              background: none;
              border: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pavilion/list.vue